export default {
    login: {
        method: 'POST',
        url: '/adminScreen/user/login',
        name: '登录接口'
    }
}
